import React, { useState } from 'react';
import { IonPage, IonHeader, IonToolbar, IonTitle, IonContent, IonButton, IonItem, IonLabel, IonInput } from '@ionic/react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import config from '../config'; // Import config

function LoginPage({ setUser }) {
  const history = useHistory();
  const [identifier, setIdentifier] = useState('');
  const [code, setCode] = useState('');
  const [showCodeInput, setShowCodeInput] = useState(false);
  const [tempUserId, setTempUserId] = useState(null);

  const handleRegister = () => {
    fetch(`${config.API_BASE_URL}/register`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username: identifier.split('@')[0], email: identifier.includes('@') ? identifier : `${identifier}@example.com` })
    })
      .then(res => {
        if (!res.ok) throw new Error(`HTTP error! Status: ${res.status}`);
        return res.json();
      })
      .then(() => alert('Registered! Check your email for a login code.'))
      .catch(err => alert('Registration failed: ' + err.message));
  };

  const handleRequestLogin = () => {
    fetch(`${config.API_BASE_URL}/request-login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ identifier })
    })
      .then(res => {
        if (!res.ok) throw new Error(`HTTP error! Status: ${res.status}`);
        return res.json();
      })
      .then(data => {
        setTempUserId(data.userId);
        setShowCodeInput(true);
        alert('Check your email for your login code!');
      })
      .catch(err => alert('Login request failed: ' + err.message));
  };

  const handleVerifyLogin = () => {
    fetch(`${config.API_BASE_URL}/verify-login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ userId: tempUserId, code })
    })
      .then(res => {
        if (!res.ok) throw new Error(`HTTP error! Status: ${res.status}`);
        return res.json();
      })
      .then(data => {
        setUser(data.token);
        history.push('/');
      })
      .catch(err => alert('Login failed: ' + err.message));
  };

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar style={{ backgroundColor: '#3498db', color: '#ffffff' }}>
          <IonTitle>Login / Register</IonTitle>
          <IonButton slot="end" onClick={() => history.push('/')}>Home</IonButton>
        </IonToolbar>
      </IonHeader>
      <IonContent style={{ backgroundColor: '#ffffff' }}>
        <IonItem>
          <IonLabel position="stacked">Username or Email</IonLabel>
          <IonInput value={identifier} onIonChange={e => setIdentifier(e.target.value)} placeholder="Enter username or email"></IonInput>
        </IonItem>
        {showCodeInput && (
          <IonItem>
            <IonLabel position="stacked">Login Code</IonLabel>
            <IonInput value={code} onIonChange={e => setCode(e.target.value)} placeholder="Enter code from email"></IonInput>
          </IonItem>
        )}
        <IonButton expand="block" onClick={handleRegister}>Register</IonButton>
        <IonButton expand="block" onClick={handleRequestLogin}>Request Login Code</IonButton>
        {showCodeInput && <IonButton expand="block" onClick={handleVerifyLogin}>Login</IonButton>}
      </IonContent>
    </IonPage>
  );
}

LoginPage.propTypes = {
  setUser: PropTypes.func.isRequired
};

export default LoginPage;